module.exports = __webpack_public_path__ + "static/media/amsh-setup.0c8acee5.svg";